<div
  class="navigation-container"
  [ngClass]="{
    'navigation-container': sidenavState() !== 'slim',
    'navigation-container-slim': sidenavState() === 'slim',
  }"
>
  @if (sidenavState() === "full" || sidenavState() === "mobile") {
    <div class="lightup-logo">
      <a
        (click)="navigateToDashboard()"
        class="flex items-center hover:cursor-pointer"
      >
        <img
          src="/assets/images/lightup-main-logo.png"
          class="w-36 mr-3"
          alt="LightUp Tutoring"
          height="76"
          width="284"
          priority
        />
      </a>
    </div>

    @if (liveLesson(); as lesson) {
      <app-live-lesson-notification [lesson]="lesson"></app-live-lesson-notification>
    }

    @if (upcomingLessons().length) {
      <app-live-lesson-countdown
        [lessons]="upcomingLessons()"
        (openSchedule)="scheduleOpen.set(true)"
      ></app-live-lesson-countdown>
      <span class="divider-line"></span>
    }

    @switch (menuService.activeContext()) {
      @case ("subscribed") {
        <app-subscribed-menu [sidenavState]="sidenavState()" (closeSidenav)="closeSidenav.emit()" />
      }
      @case ("freeTaster") {
        <app-free-taster-menu [sidenavState]="sidenavState()" (closeSidenav)="closeSidenav.emit()" />
      }
      @default {
        @if (menuService.showLiveLessonsInOnboarding()) {
          <app-menu-section
            [section]="menuService.liveLessonsOnlySection()"
            (itemSelect)="onFeatureItemSelect($event)"
          />
        }
        @if (menuService.showFreeTasterInOnboarding()) {
          <app-menu-section
            [section]="menuService.freeTasterOnlySection()"
            (itemSelect)="onFeatureItemSelect($event)"
          />
        }
        @if (menuService.showPackagesInOnboarding()) {
          <app-menu-section
            [section]="menuService.packagesOnlySection()"
            (itemSelect)="onFeatureItemSelect($event)"
          />
        }
        @if (menuService.showCampaignsInOnboarding()) {
          <app-menu-section
            [section]="menuService.campaignsOnlySection()"
            (itemSelect)="onFeatureItemSelect($event)"
          />
        }
      }
    }

    <div class="bottom-nav-bar-actions">
      <div [matMenuTriggerFor]="aboveMenu" class="profile-card">
        <div class="profile-card-content">
          <span class="avatar-container">
            <img
              class="user-avatar"
              [src]="
                avatar() && avatar().includes('images/')
                  ? avatar()
                  : 'assets/images/dashboard-avatar/placeholder.jpg'
              "
              alt="user-avatar"
            />
          </span>
          <div class="user-info-container">
            <span class="full-name">{{ fullUserName() }}</span>
            @if (yearGroup()) {
              <span class="year-group">{{ yearGroup() }}</span>
            }
          </div>
        </div>
      </div>

      @if (sidenavState() !== "mobile") {
        <app-button
          size="sm"
          variant="text"
          (onClick)="toggleDesktopSidenav.emit()"
        >
          <span
            matTooltip="Collapse"
            class="material-symbols-outlined grey-icon"
          >
            dock_to_right
          </span>
        </app-button>
      }

      @if (sidenavState() === "mobile") {
        <app-button
          size="sm"
          variant="text"
          class="close-btn"
          (click)="closeSidenav.emit()"
        >
          <span class="material-symbols-outlined grey-icon"
          >right_panel_open</span
          >
        </app-button>
      }
    </div>
  } @else if (sidenavState() === "slim") {
    <div class="lightup-logo-slim">
      <a
        (click)="navigateToDashboard()"
        class="flex items-center hover:cursor-pointer"
      >
        <img
          src="/assets/images/bulb-logo.png"
          alt="LightUp Tutoring"
          height="76"
          width="76"
          priority
        />
      </a>
    </div>

    @switch (menuService.activeContext()) {
      @case ("subscribed") {
        <app-subscribed-menu [sidenavState]="sidenavState()" (closeSidenav)="closeSidenav.emit()" />
      }
      @case ("freeTaster") {
        <app-free-taster-menu [sidenavState]="sidenavState()" (closeSidenav)="closeSidenav.emit()" />
      }
      @default {
        @if (menuService.showFreeTasterInOnboarding()) {
          <app-menu-section
            [section]="menuService.freeTasterOnlySection()"
            [iconOnly]="true"
            (itemSelect)="onFeatureItemSelect($event)"
          />
        }
        @if (menuService.showPackagesInOnboarding()) {
          <app-menu-section
            [section]="menuService.packagesOnlySection()"
            [iconOnly]="true"
            (itemSelect)="onFeatureItemSelect($event)"
          />
        }
      }
    }

    <div class="bottom-nav-bar-actions slim-actions">
      <div [matMenuTriggerFor]="aboveMenu" class="user-initial-container">
        <span class="user-initial" matTooltip="Profile">{{
            userInitial()
          }}</span>
      </div>

      <app-button
        class="slim-expand-btn"
        variant="text"
        (onClick)="toggleDesktopSidenav.emit()"
      >
        <span matTooltip="Expand" class="material-symbols-outlined grey-icon"
        >dock_to_left</span
        >
      </app-button>
    </div>
  }
</div>

<app-live-lesson-schedule
  [isOpen]="scheduleOpen()"
  [lessons]="scheduleLessons()"
  [tags]="liveLessonSvc.tags()"
  (closed)="scheduleOpen.set(false)"
/>

<mat-menu #aboveMenu="matMenu" yPosition="above">
  @if (subscriptionStore.isSubscribed()) {
    <button (click)="goToHowToUse()" mat-menu-item class="menu-button">
    <span class="menu-button-content">
      <span class="material-symbols-outlined menu-button-icon">lightbulb</span>
      <span>How to use</span>
    </span>
    </button>
  }
  <button (click)="goToSettings()" mat-menu-item class="menu-button">
    <span class="menu-button-content">
      <img src="assets/images/settings.svg" class="menu-button-icon-img" />
      <span>Settings</span>
    </span>
  </button>
  <button (click)="openSupport()" mat-menu-item class="menu-button">
    <span class="menu-button-content">
      <img src="assets/images/support-icon.svg" class="menu-button-icon-img" />
      <span>Support</span>
    </span>
  </button>
  <button (click)="logout.emit()" mat-menu-item class="menu-button">
    <span class="menu-button-content">
      <span class="material-symbols-outlined menu-button-icon">logout</span>
      <span>Logout</span>
    </span>
  </button>
</mat-menu>
